<div class="flex gap-3 cursor-pointer group items-start select-none">
    <div class="wrapper" [class.active]="active()">
        <div class="circle" [class.active]="active()"></div>
    </div>
    <div class="flex flex-col gap-1 leading-none">
        <p class="theme-text text-base">
            {{ label() }}
        </p>
        @if (description(); as description) {
            <p class="theme-text" class="text-sm text-gray-500">
                {{ description }}
            </p>
        }
    </div>
</div>
